import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentCount = createSelector(
  [(store: RootState) => store.documentsList.count],
  (count) => count
);
